import intl from 'react-intl-universal';

export const METHOD_TYPE = {
  password: 1,
  certificate: 2,
};

export const ENCRYPTED_TYPE = {
  unknown: -1,
  default: 1,
};

export const ItemsKey = 'security_policies_items';

export const getItems = () => {
  return JSON.parse(localStorage.getItem(ItemsKey) || '[]');
};

/**
 * Add or replace.
 * @param item
 * @returns {any}
 */
export const setItem = (item) => {
  const items = getItems();
  item.modifyDate = getNow();
  const index = items.findIndex(it => it.id === item.id);
  if (index >= 0) {
    items.splice(index, 1, item);
  } else {
    item.id = getUniqueId();
    items.push(item);
  }
  localStorage.setItem(ItemsKey, JSON.stringify(items));

  return {...item};
}

export const removeItem = (item) => {
  if (!item) return;

  const items = getItems();
  const index = items.findIndex(it => it.id === item.id);
  if (index >= 0) {
    items.splice(index, 1);
    localStorage.setItem(ItemsKey, JSON.stringify(items));
  }
}

export const getNow = (fmt = 'yyyy-MM-dd hh:mm:ss') => {
  return new Date().format(fmt);
}

let uniqueIdIndex = 0;
export const getUniqueId = () => {
  return ['unique', new Date().getTime(), uniqueIdIndex++].join('_');
}

function getNameSuffix(namePrefix) {
  const items = getItems();
  let nameSuffix = 1;
  while (items.some(it => it.name === `${namePrefix}${nameSuffix}`)) {
    nameSuffix++;
  }
  return nameSuffix;
}
export function newSecurityPolicy({namePrefix, method, certificateProtectData }) {
  const nameSuffix = getNameSuffix(namePrefix);
  const securityUtils = window.UIExtension.PDFViewCtrl.shared.securityUtils;
  const data = {
    method: method,
    name: `${namePrefix}${nameSuffix}`,
    desc: '',
    encrypted: ENCRYPTED_TYPE.default,
    ...securityUtils.getPermissionDefaultUIData('password'),
  };
  if (method === METHOD_TYPE.certificate) {
    data.certificateProtectData = certificateProtectData || {};
  }
  return setItem(data);
}

export function passwordProtectSaveSecurityPolicy(permissionData) {
  const namePrefix = intl.get('SecurityPolicies.UntitledPolicy');
  const nameSuffix = getNameSuffix(namePrefix);
  const method = METHOD_TYPE.password;
  const data = {
    method: method,
    name: `${namePrefix}${nameSuffix}`,
    desc: '',
    encrypted: ENCRYPTED_TYPE.default,
    ...permissionData
  };
  return setItem(data);
}